'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var classnames = require('classnames');
var libphonenumberJs = require('libphonenumber-js');
var examples_mobile = require('../../../data/examples.mobile.json.js');
var countries = require('../../../data/countries.js');
var index = require('../Flag/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var DOWN_ARROW_KEY_CODE = 40;
var UP_ARROW_KEY_CODE = 38;
var ESCAPE_KEY_CODE = 27;
var ENTER_KEY_CODE = 13;
var ITEM_HEIGHT = 27;

var PhoneInput = function PhoneInput(_ref) {
  var id = _ref.id,
      disabled = _ref.disabled,
      errored = _ref.errored,
      country = _ref.country,
      metadata = _ref.metadata,
      onPhoneChange = _ref.onPhoneChange,
      onPhoneFocus = _ref.onPhoneFocus,
      onPhoneBlur = _ref.onPhoneBlur,
      className = _ref.className;
  var countries = Object.keys(metadata).reduce(function (memo, c) {
    var phoneNumber = libphonenumberJs.getExampleNumber(c, examples_mobile.default);

    if (phoneNumber != null) {
      memo.codes.push(c);
      memo.names.push(metadata[c]);
    }

    return memo;
  }, {
    codes: [],
    names: []
  });

  var _useReducer = React.useReducer( // eslint-disable-next-line no-shadow
  function (state, action) {
    var index;

    switch (action.type) {
      case 'search':
        return _rollupPluginBabelHelpers.objectSpread2({}, state, {
          countryIndex: action.index
        });

      case 'up':
        return _rollupPluginBabelHelpers.objectSpread2({}, state, {
          countryIndex: Math.max(0, state.countryIndex - 1)
        });

      case 'down':
        return _rollupPluginBabelHelpers.objectSpread2({}, state, {
          countryIndex: Math.min(state.countryIndex + 1, countries.codes.length)
        });

      case 'open':
        return _rollupPluginBabelHelpers.objectSpread2({}, state, {
          open: true
        });

      case 'close':
        index = countries.codes.indexOf(state.country);
        return _rollupPluginBabelHelpers.objectSpread2({}, state, {
          open: false,
          countryIndex: index
        });

      case 'country':
        {
          index = countries.codes.indexOf(action.country);
          return _rollupPluginBabelHelpers.objectSpread2({}, state, {
            country: action.country,
            countryIndex: index,
            open: false,
            number: '',
            valid: false
          });
        }

      case 'number':
        return _rollupPluginBabelHelpers.objectSpread2({}, state, {
          number: action.number,
          valid: action.valid
        });

      default:
        return state;
    }
  }, {
    country: country,
    countryIndex: countries.codes.indexOf(country),
    number: '',
    open: null
  }),
      _useReducer2 = _rollupPluginBabelHelpers.slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var groupRef = React.useRef();
  var dropdownRef = React.useRef();
  var inputRef = React.useRef();
  var selectedCountry = React.useMemo(function () {
    var flag = state.country;
    var phoneNumber = libphonenumberJs.getExampleNumber(state.country, examples_mobile.default);
    return {
      flag: flag,
      code: phoneNumber.countryCallingCode,
      placeholder: phoneNumber.formatNational().replace(/\d/g, '0').replace(/[()]/g, '')
    };
  }, [state.country]);
  React.useLayoutEffect(function () {
    if (dropdownRef.current) {
      dropdownRef.current.scrollTop = state.countryIndex * ITEM_HEIGHT + 10 - dropdownRef.current.offsetHeight / 2;
      dropdownRef.current.focus();
    }
  }, [state.open, state.countryIndex]);
  React.useEffect(function () {
    if (inputRef.current != null && state.open === false) {
      inputRef.current.focus();
    }
  }, [state.countryIndex]);
  React.useEffect(function () {
    onPhoneChange({
      countryCode: selectedCountry.code,
      number: state.number.replace(/[()-/\s]/g, '')
    });
  }, [selectedCountry.code, state.number, onPhoneChange]);

  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === 8) {
      e.preventDefault();
      var asYouType = new libphonenumberJs.AsYouType(state.country);
      var next = state.number.slice(0, -1);
      var value = asYouType.input(next);
      var isValid = asYouType.isValid();
      dispatch({
        type: 'number',
        number: isValid ? value : next,
        valid: isValid
      });
    }
  };

  var onChange = function onChange(e) {
    var asYouType = new libphonenumberJs.AsYouType(state.country);
    var value = asYouType.input(e.target.value);
    dispatch({
      type: 'number',
      number: value,
      valid: asYouType.isValid()
    });
  }; // eslint-disable-next-line no-shadow


  var onSelect = function onSelect(country) {
    return dispatch({
      type: 'country',
      country: country
    });
  };

  var onFocus = function onFocus(e) {
    groupRef.current.classList.toggle('focused', true);

    if (e.target === inputRef.current) {
      onPhoneFocus();
    }
  };

  var onBlur = function onBlur(e) {
    groupRef.current.classList.toggle('focused', false);

    if (e.target === inputRef.current) {
      onPhoneBlur();
    }
  };

  var onClick = function onClick() {
    dispatch({
      type: 'open'
    });
  };

  var onClickOutside = function onClickOutside(event) {
    if (groupRef.current != null && !groupRef.current.contains(event.target) && state.open === true) {
      dispatch({
        type: 'close'
      });
    }
  };

  var onKeyDownGlobal = function onKeyDownGlobal(event) {
    if (groupRef.current.contains(event.target)) {
      if (event.keyCode >= 60 && event.keyCode <= 90) {
        var _index = countries.names.findIndex(function (v) {
          var _v$toLocaleLowerCase$ = v.toLocaleLowerCase().split(''),
              _v$toLocaleLowerCase$2 = _rollupPluginBabelHelpers.slicedToArray(_v$toLocaleLowerCase$, 1),
              first = _v$toLocaleLowerCase$2[0];

          return first === event.key;
        });

        if (_index >= 0) {
          dispatch({
            type: 'search',
            index: _index
          });
        }

        return;
      }

      switch (event.keyCode) {
        case DOWN_ARROW_KEY_CODE:
          if (state.open) {
            event.preventDefault();
            dispatch({
              type: 'down'
            });
          }

          break;

        case UP_ARROW_KEY_CODE:
          if (state.open) {
            event.preventDefault();
            dispatch({
              type: 'up'
            });
          }

          break;

        case ESCAPE_KEY_CODE:
          if (inputRef.current != null) {
            inputRef.current.focus();
          }

          dispatch({
            type: 'close'
          });
          break;

        case ENTER_KEY_CODE:
          if (state.open) {
            event.preventDefault();
            onSelect(countries.codes[state.countryIndex]);
          }

          break;
      }
    }
  };

  React.useEffect(function () {
    var dropdown = dropdownRef.current;
    document.addEventListener('click', onClickOutside, true);

    if (dropdown) {
      dropdown.addEventListener('keydown', onKeyDownGlobal, true);
    }

    return function () {
      document.removeEventListener('click', onClickOutside, true);

      if (dropdown) {
        dropdown.removeEventListener('keydown', onKeyDownGlobal, true);
      }
    };
  }, [state.open, state.countryIndex]);
  var cssClassNames = classnames__default['default']({
    'ds-atom-phone-input': true,
    disabled: disabled,
    errored: errored
  });
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(cssClassNames, " ").concat(className),
    ref: groupRef
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    className: classnames__default['default']({
      'ds-atom-phone-input-country': true,
      'ds-mol-option-picker-trigger': true,
      'ds-mol-option-picker-open': state.open,
      'ds-mol-option-picker-closed': !state.open
    }),
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React__default['default'].createElement(index, {
    className: "ds-atom-phone-flag",
    flag: selectedCountry.flag.toLowerCase()
  }), /*#__PURE__*/React__default['default'].createElement("span", null, "+", selectedCountry.code)), /*#__PURE__*/React__default['default'].createElement("input", {
    ref: inputRef,
    id: id,
    disabled: disabled,
    className: "ds-atom-phone-input-number",
    onKeyDown: onKeyDown,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    value: state.number,
    placeholder: selectedCountry.placeholder
  }), state.open && /*#__PURE__*/React__default['default'].createElement("ul", {
    ref: dropdownRef,
    className: "ds-atom-phone-input-dropdown ds-mol-dropdown",
    role: "listbox",
    tabIndex: 0
  }, countries.codes.map(function (c, index$1) {
    var code = libphonenumberJs.getCountryCallingCode(c);
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: c
    }, /*#__PURE__*/React__default['default'].createElement("button", {
      className: classnames__default['default']({
        'ds-atom-phone-input-option': true,
        selected: state.country === c || state.countryIndex === index$1
      }),
      onClick: function onClick() {
        onSelect(c);
      },
      type: "button"
    }, /*#__PURE__*/React__default['default'].createElement(index, {
      className: "ds-atom-phone-flag",
      flag: c.toLowerCase()
    }), "".concat(countries.names[index$1], " +").concat(code)));
  })));
};

PhoneInput.propTypes = {
  id: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  errored: PropTypes__default['default'].bool,
  country: PropTypes__default['default'].string,
  onPhoneChange: PropTypes__default['default'].func,
  onPhoneFocus: PropTypes__default['default'].func,
  onPhoneBlur: PropTypes__default['default'].func,
  metadata: PropTypes__default['default'].object,
  className: PropTypes__default['default'].string
};
PhoneInput.defaultProps = {
  id: 'phone',
  disabled: false,
  errored: false,
  country: 'ES',
  onPhoneChange: function onPhoneChange() {},
  onPhoneBlur: function onPhoneBlur() {},
  onPhoneFocus: function onPhoneFocus() {},
  metadata: countries,
  className: ''
};

module.exports = PhoneInput;
